var Apidae_Geo = (function() {
    let self = {};
    let latitude = null;
    let longitude = null;
    let p1 = '';
    let p2 = '';
    let status = document.querySelector('#searchAlert');
    let distance = document.querySelector('#searchByGeoRange') ? document.querySelector('#searchByGeoRange').value : '';

    Number.prototype.toRadians = function() { return this * Math.PI / 180; };
    Number.prototype.toDegrees = function() { return this * 180 / Math.PI; };

    self.geolocalisation = function() {
        return new Promise(function(resolve, reject) {
            if (loadData === false) {
                loadData = true;
                navigator.geolocation.getCurrentPosition((position) => {
                    resolve([position.coords.latitude, position.coords.longitude]);
                });
                loadData = false;
            }
        })
    };
 
    self.search = async function() {
        if (!navigator.geolocation) {
            status.textContent = 'La géolocation n\'est pas supporté par votre navigateur.';
        } else {
            status.textContent = 'Localisation…';
            self.geolocalisation()
                .then(
                    latlng => {
                        latitude = latlng[0]
                        longitude = latlng[1]

                        if (latitude && longitude) {
                            
                            status.textContent = `Latitude: ${latitude.toFixed(4)} °, Longitude: ${longitude.toFixed(4)} °`;
                            p1 = self.destinationPoint(latitude, longitude, distance, 225);
                            console.log(p1);
                            p2 = self.destinationPoint(latitude, longitude, distance, 45);
                            console.log(p2);

                            var South_Lat = p1[0];
                            var South_Lng = p1[1];
                            var North_Lat = p2[0];
                            var North_Lng = p2[1];

                            if (South_Lat > jQuery('#South_Lat_Min').val() && South_Lng > jQuery('#South_Lng_Min').val() && North_Lat < jQuery('#North_Lat_Max').val() && North_Lng < jQuery('#North_Lng_Max').val()) {

                                jQuery('#South_Lat').val(South_Lat);
                                jQuery('#South_Lng').val(South_Lng);
                                jQuery('#North_Lat').val(North_Lat);
                                jQuery('#North_Lng').val(North_Lng);

                                console.log(distance)
                                Apidae_Search.search();
                            }else{
                                status.textContent = 'La géolocalisation ne permet pas de vous situer sur place.';
                                jQuery("#critereSearchByGeo").val(0).attr('checked', false);
                                jQuery("#searchByGeoButton").removeClass('is-checked');
                                jQuery("#searchByGeoRangeWrapper").addClass('disabled');
                            }
                        }
                    }
                )
                .catch(() => {
                    status.textContent = `Une erreur est survenue`;
                });
        }
    }

    /**
     * Returns the destination point from ‘this’ point having travelled the given distance on the
     * given initial bearing (bearing normally varies around path followed).
     *
     * @param   {number} distance - Distance travelled, in same units as earth radius (default: metres).
     * @param   {number} bearing - Initial bearing in degrees from north.
     * @param   {number} [radius=6371e3] - (Mean) radius of earth (defaults to radius in metres).
     * @returns {LatLon} Destination point.
     *
     * @example
     *   const p1 = new LatLon(51.47788, -0.00147);
     *   const p2 = p1.destinationPoint(7794, 300.7); // 51.5136°N, 000.0983°W
     */
    self.destinationPoint = function(latitude, longitude, distance, bearing, radius = 6371e3) {
        // sinφ2 = sinφ1⋅cosδ + cosφ1⋅sinδ⋅cosθ
        // tanΔλ = sinθ⋅sinδ⋅cosφ1 / cosδ−sinφ1⋅sinφ2
        // see mathforum.org/library/drmath/view/52049.html for derivation

        const δ = distance / radius; // angular distance in radians
        const θ = Number(bearing).toRadians();

        const φ1 = Number(latitude).toRadians(),
            λ1 = Number(longitude).toRadians();

        const sinφ2 = Math.sin(φ1) * Math.cos(δ) + Math.cos(φ1) * Math.sin(δ) * Math.cos(θ);
        const φ2 = Math.asin(sinφ2);
        const y = Math.sin(θ) * Math.sin(δ) * Math.cos(φ1);
        const x = Math.cos(δ) - Math.sin(φ1) * sinφ2;
        const λ2 = λ1 + Math.atan2(y, x);

        const lat = Number(φ2).toDegrees();
        const lon = Number(λ2).toDegrees();

        return [lat, lon];
    }

    self.init = function() {
        const searchByGeoButton = document.querySelector('#searchByGeoButton')
        searchByGeoButton.addEventListener('click', () => {
            searchByGeoButton.classList.toggle('is-checked');
            var critereSearchByGeo = document.querySelector('#critereSearchByGeo').checked;
            // console.log(critereSearchByGeo);
            if (critereSearchByGeo) {
                jQuery("#critereSearchByGeo").val(0).attr('checked', false);
                // jQuery("#searchByGeoButton").removeClass('selected');
                jQuery("#searchByGeoRangeWrapper").addClass('disabled');
            } else {
                jQuery("#critereSearchByGeo").val(1).attr('checked', true);
                // jQuery("#searchByGeoButton").addClass('selected');
                jQuery("#searchByGeoRangeWrapper").removeClass('disabled');
            }
            self.search();
        });

        document.querySelector('#searchByGeoRange').addEventListener('change', (event) => {
            console.log(event.target.value)
            distance = event.target.value;
            self.search()
        });
    };

    return self;
})();

jQuery(window).on("load", function() {
    if (jQuery('#searchByGeoButton').length) {
        Apidae_Geo.init();
    }
});